import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton, makeStyles,
} from '@material-ui/core';
import {
  File as DownloadIcon,
} from 'react-feather';

const useStyles = makeStyles((theme) => ({
  icon: {
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

/**
 * Componente que muestra el boton descargar
 * @param {*} param0
 */
const DownloadPdfButton = ({
  onClick,
}) => {
  const classes = useStyles();
  return (
    <IconButton
      className={classes.icon}
      onClick={onClick}
    >
      <DownloadIcon />
    </IconButton>
  );
};

DownloadPdfButton.propTypes = {
  onClick: PropTypes.func,
};

export default DownloadPdfButton;
